import { useContext } from 'react';
import { isMobile } from 'react-device-detect';

import { AnalyticsContext } from 'contexts/analytics';
import { IFullCHartData } from 'contexts/analytics/types';
import SlideButtonsGroup from '../SlideButtonsGroup';
import ChartDataSelector from '../ChartDataSelector';
import { Container } from './styles';
import './statics.scss';
import ActiveUsersChart from '../ActiveUsersChart';
import { Spinner } from 'components/loadings';
import { ChartSeriesConfig } from 'utils/chartCsvExport';
import { formatChartXAxisLabel } from 'utils/chartXAxisLabel';

const chartTypes = [
  { icon: 'LineChart', value: 'AreaChart' },
  { icon: 'BarChart', value: 'BarChart' },
];

interface Props {
  dataDisplay: ChartSeriesConfig[];
  toggleCheckbox: (key: string) => void;
  hideChartTypeSelector?: boolean;
  isDashboardChart?: boolean;
  chartType: string;
  updateChartType: (value: string) => void;
  chartContainerRef: React.RefObject<HTMLDivElement>;
  chartItems: IFullCHartData[];
}

const AnalyticsActivitiesChart = ({
  toggleCheckbox,
  dataDisplay,
  hideChartTypeSelector,
  isDashboardChart,
  chartType,
  updateChartType,
  chartContainerRef,
  chartItems,
}: Props): JSX.Element => {
  const { activities, currentChart, filters } = useContext(AnalyticsContext);

  const formatXAxisLabel = (date: string, index: number) =>
    formatChartXAxisLabel(date, index, filters?.period);

  const showDataSelector = dataDisplay.length > 1;

  return (
    <>
      <Spinner
        active={activities.loading}
        top={isMobile ? '250px' : '50%'}
        left="50%"
        position="absolute"
      />
      <Container lock={activities.loading}>
        {(showDataSelector || !hideChartTypeSelector) && (
          <div className="activities-chart__controls-row">
            {showDataSelector && (
              <ChartDataSelector
                className="desktop-only"
                toggleCheckbox={toggleCheckbox}
                options={dataDisplay}
                chartType={chartType}
                isDashboardChart={isDashboardChart}
              />
            )}
            {!hideChartTypeSelector && (
              <div className="activities-chart__chart-type-selector">
                <SlideButtonsGroup
                  action={updateChartType}
                  options={chartTypes}
                  current={chartType}
                />
              </div>
            )}
          </div>
        )}
        <div ref={chartContainerRef} style={{ display: 'contents' }}>
          <ActiveUsersChart
            items={chartItems}
            chartType={chartType}
            chartDataType={currentChart}
            Xaxis="date"
            Yaxis="count"
            dataDisplay={dataDisplay}
            formatXAxisLabel={formatXAxisLabel}
          />
        </div>
        <div className="activities-chart__options-container activities-chart__options-container-mob">
          <ChartDataSelector
            className="mobile-only"
            toggleCheckbox={toggleCheckbox}
            options={dataDisplay}
            chartType={chartType}
          />
        </div>
      </Container>
    </>
  );
};

export default AnalyticsActivitiesChart;
